module.exports = __webpack_public_path__ + "static/media/outfit11.1469e610.jpg";